import gql from 'graphql-tag';

export default gql`
    mutation DeleteDriverLoadStatus($input: DriverLoadStatusDeleteRequest) {
        deleteDriverLoadStatus(input: $input) {
            errors
        }
    }
`;
